<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="preAtendimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="instaciado">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulários</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <h3>{{ marcacao.nome_paciente }}</h3>
                            <h5 v-if="marcacao.procedimento">{{ marcacao.procedimento.search }}</h5>
                            <h5 v-if="marcacao.medico">{{ marcacao.medico.search }}</h5>
                        </div>
                        <az-empty-state v-if="!dados || !dados.length" msg="Nenhum questionário disponível para esse procedimento." />

                        <ul class="list-group" v-if="!item">
                            <li class="list-group-item d-flex justify-content-between" v-for="(modelo, imx) in dados" :key="imx">
                                <div class="lead">
                                    {{ modelo.search }}

                                    <a :href="modelo.doc_pre_atend.doc_certificado.arquivo.temporary_url" target="_blank" v-if="modelo.doc_pre_atend && modelo.doc_pre_atend.doc_certificado && modelo.doc_pre_atend.doc_certificado.arquivo" class="ml-2">
                                        <i class="fas fa-file-contract ml-2"></i>
                                    </a>

                                    <span v-if="modelo.doc_pre_atend && modelo.doc_pre_atend.laudo_status">
                                        <span class="badge badge-info ml-2">
                                            {{ modelo.doc_pre_atend.laudo_status.status_laudo.search }}
                                        </span>
                                    </span>
                                </div>
                                <button type="button" class="btn btn-outline-success btn-sm" 
                                    v-if="modelo.doc_pre_atend.id_documento_pre_atendimento && modelo.doc_pre_atend.fl_preenchido_pelo_paciente && !$store.state.user.medico"
                                    disabled>
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                </button>
                                <button type="button" class="btn btn-outline-primary btn-sm" 
                                    v-else-if="modelo.doc_pre_atend.id_documento_pre_atendimento"
                                    @click="item = modelo.doc_pre_atend">
                                    <i class="fas fa-edit"></i>
                                </button>
                                <button type="button" class="btn btn-outline-primary btn-sm" 
                                    v-else
                                    @click="incluir(modelo)">
                                    <i class="fas fa-plus"></i>
                                </button>
                            </li>
                        </ul>

                        <template v-if="item">

                            <az-sub-title :title="item.st_titulo" :big="true">
                                <span class="small text-muted mr-2" title="Id do Modelo">#{{ item.id_modelo_prontuario }}</span>

                                {{ item.created_at ? ( $util.getFormatDate(item.created_at.substr(0, 10)) + item.created_at.substr(10, 6) ) : '' }}

                                <span class="ml-3">
                                    <a href="#" @click.prevent="toggle_buscar_proc()" class="card-link">
                                        <i class="fa-solid fa-magnifying-glass-arrow-right" title="Buscar dados de outro atendimento."></i>
                                    </a>
                                </span>

                                <span class="ml-3">
                                    <a href="#" @click.prevent="item = null" class="card-link">
                                        <i class="fa-solid fa-chevron-left" title="Voltar"></i>
                                    </a>
                                </span>
                            </az-sub-title>

                            <buscar-procedimento 
                                ref="busca" 
                                :id_paciente="marcacao.id_paciente" 
                                v-show="buscar_proc"
                                @selecionado="herdar_selecionado" />

                            <formulario 
                                :compact="item.fl_compact"
                                v-model="item.js_conteudo" 
                                v-if="item" 
                                :saved="saved" 
                                mode="fixed"
                                :config="true" />

                            <button type="button" class="btn btn-secondary mt-3" @click="item = null">Voltar</button>

                        </template>

                        <pre v-if="1 == 0">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <div class="mt-1 mr-2" v-if="item">
                            <az-input 
                                type="checkbox-group"
                                label="Imprimir" 
                                v-model="impressao" />
                        </div>
                        <az-audit-log-button model="documentoPreAtendimento" :id="item.id_documento_pre_atendimento" v-if="item && item.id_documento_pre_atendimento" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="item && !item.doc_certificado" @click="atualizar()">Atualizar</az-submit>
                        <az-submit v-if="item && !item.doc_certificado && pode_assinar(item)" @click="atualizar(true)">Atualizar e Assinar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <DocumentoIPSign
            ref="documentoIPSignRef"
            :model_id="item ? item.id_documento_pre_atendimento : null"
            model_type="documentoPreAtendimento"
        />

        <DocumentoZerodox
            ref="documentoZerodoxRef"
            :model_id="item ? item.id_documento_pre_atendimento : null"
            model_type="documentoPreAtendimento"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzEmptyState from '../util/AzEmptyState.vue';
import Formulario from '../modulos/consultorio/Formulario.vue';
import AzSubmit from '../util/AzSubmit.vue';
import AzSubTitle from '../util/AzSubTitle.vue';
import AzAuditLogButton from '../util/AzAuditLogButton.vue';
import AzInput from '../shared/forms/AzInput.vue';
import BuscarProcedimento from './BuscarProcedimento.vue';
import DocumentoIPSign from "../shared/DocumentoIPSign.vue";
import DocumentoZerodox from "../shared/DocumentoZerodox.vue";

export default {
    data() { 
        return { 
           dados: null,
           instaciado: false, 
           marcacao: null, 
           item: null, 
           saved: true, 
           impressao: false, 
           validade: false, 
           buscar_proc: false, 
           ipsign: false, 
        }
    },

    props: ['pep'], 

    components: { 
        AzEmptyState,
        Formulario, 
        AzSubmit, 
        AzSubTitle,
        AzAuditLogButton, 
        AzInput, 
        BuscarProcedimento, 
        DocumentoIPSign,
        DocumentoZerodox,
    },

    methods: { 
        pode_assinar(item) {
            const modelo = this.dados.find(mod => { 
                return mod.doc_pre_atend.id_documento_pre_atendimento === item.id_documento_pre_atendimento;
            });

            return modelo && modelo.fl_ass_externa;
        },

        herdar_selecionado (campos) { 
            this.$utilform.preencher_campos(this.item.js_conteudo, campos)
            this.toggle_buscar_proc();
        },

        toggle_buscar_proc () { 
            this.buscar_proc = !this.buscar_proc;

            if ( this.buscar_proc ) { 
                this.$refs.busca.exibir();
            }
        },

        incluir (modelo) { 
            let valores = {}
            
            this.dados.filter(mod => { 
                return mod.doc_pre_atend.id_documento_pre_atendimento;
            })
            .forEach(mod => { 
                valores = _.merge(valores, this.$utilform.obter_campos(mod.doc_pre_atend.js_conteudo));
            });
            
            modelo.doc_pre_atend.js_conteudo = this.$utilform.preencher_campos(
                modelo.doc_pre_atend.js_conteudo, 
                valores
            );

            this.item = modelo.doc_pre_atend;
        },

        atualizar (ass_ipsign = false) { 
            console.log(this.item);
            this.$util.atualizar(this, { 
                service: 'documentos_pre_atendimento',
                func: 'store',
                dados: { 
                    ...this.item,
                    ass_ipsign: ass_ipsign
                },
                modal: 'preAtendimentoModal',
                callback: res => { 
                    if ( ass_ipsign ) {
                        if(res && res.base64) {
                            const nome = _.get(this.marcacao, 'paciente.st_nome', _.get(this.marcacao, 'cadastro_temporario.st_nome'));
                            const cpf = _.get(this.marcacao, 'paciente.cadastro.st_cpf', _.get(this.marcacao, 'cadastro_temporario.st_cpf'));
                            const email = _.get(this.marcacao, 'paciente.cadastro.st_email', _.get(this.marcacao, 'cadastro_temporario.st_email'));
                            const dt_nascimento = _.get(this.marcacao, 'paciente.cadastro.dt_nascimento', _.get(this.marcacao, 'cadastro_temporario.dt_nascimento'));

                            let unidade = _.get( this.marcacao, "unidade_operacao.st_nome");
                            let operadora = _.get( this.marcacao, "plano.search");

                            // quantidade de ocorrencias da tag de assinatura
                            var qtdOcorrenciasAss = 0;
                            // if (this.documento && this.documento.st_chave_assinatura_ipsign) {
                            //     var substrings = this.documento.st_descricao.split(this.documento.st_chave_assinatura_ipsign);
                            //     if (substrings && substrings.length > 0) {
                            //         qtdOcorrenciasAss = substrings.length - 1;
                            //     }
                            // }

                            if (res.zerodox) {
                                this.$refs.documentoZerodoxRef.show(
                                    res.base64,
                                    this.item.st_titulo,
                                    email,
                                    cpf,
                                    nome,
                                    unidade,
                                    operadora,
                                    dt_nascimento,
                                    // m_id,
                                    // m_type,
                                    // this.atendimento ? this.atendimento.id_atendimento : null
                                );
                            } else if ( res.ipsign ) {
                                // IPSIGN
                                this.$refs.documentoIPSignRef.show(
                                    res.base64,
                                    this.item.st_titulo,
                                    email,
                                    cpf,
                                    nome,
                                    unidade,
                                    operadora,
                                    'ASS:', // TODO: verificar com André - this.documento.st_chave_assinatura_ipsign,
                                    qtdOcorrenciasAss,
                                    dt_nascimento,
                                    // m_id,
                                    // m_type,
                                    // this.atendimento ? this.atendimento.id_atendimento : null
                                );
                            } else {

                                console.log(res);

                                this.$toast.add({
                                    severity: 'error',
                                    summary: 'Erro',
                                    detail: 'Nenhum método de assinatura disponível para este documento.',
                                    life: 5000
                                });

                            }

                        } else {

                            console.log(res);

                            this.$toast.add({
                                severity: 'error',
                                summary: 'Erro',
                                detail: res.msg 
                                    ? res.msg 
                                    : 'O documento foi atualizado com sucesso, mas não foi possível gerar o arquivo para assinatura neste momento.',
                                life: 5000
                            });

                        }

                    } else if ( this.impressao ) { 
                        //alert('Imprimir...');
                        this.$util.print_preview('imprimir/documentoPreAtendimento/' + res.id_documento_pre_atendimento, true);
                    }

                    this.$emit('refresh');
                }
            });
        },

        abrir (marcacao, doc_pre = null) { 

            this.item = null;
            this.marcacao = marcacao;
            this.instaciado = true;
            
            this.dados = null;
            this.$store.commit('loading', true);

            $('#preAtendimentoModal').modal('show');

            this.$util.loadItem(this, { 
                service: 'documentos_pre_atendimento', 
                func: 'lista', 
                parms: { 
                    id_marcacao: marcacao.id_marcacao, 
                    pep: this.pep ? true : false,
                },
                configs: [
                    'integracao-ipsign', 
                ]
            })
            .then(res => { 
                console.log(res);
                this.dados = res;
                this.ipsign = !!this.$store.state.contexto['integracao-ipsign'];

                if (doc_pre) {
                    let modelo = this.dados.find(mod => { 
                        return mod.doc_pre_atend && ( mod.doc_pre_atend.id_documento_pre_atendimento === doc_pre.id_documento_pre_atendimento );
                    });

                    if ( modelo ) { 
                        this.item = modelo.doc_pre_atend;
                    }
                }
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

        }
    }
}
</script>